import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { ISbStoryData } from '@storyblok/js';
import { PICFLOW_CONFIG } from '../../../picflow-config';
import { ShareMenuComponent } from '../../../shared-extra/components/share-menu/share-menu.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-article-share',
  imports: [ButtonDirective, SvgComponent, ContextMenuComponent, ShareMenuComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './article-share.component.html',
  styleUrl: './article-share.component.scss',
})
export class ArticleShareComponent {
  private config = inject(PICFLOW_CONFIG);
  readonly story = input.required<ISbStoryData>();

  shareLink = computed(() => {
    const story = this.story();
    return `${this.config.correctPicflowUrl}/${story.full_slug}`;
  });
}
